import { ReactNode } from 'react';

import { WithRef } from 'support/types/withRef';
import { StatusBubbleVariant } from 'components/Display/StatusBubble/StatusBubble';
import { InfoPopover, InfoPopoverBody, InfoPopoverFooter } from 'components/InfoPopover/InfoPopover';

import { Header } from './components/Header';

type FieldAnnotationPopoverShellProps = {
  style?: React.CSSProperties;
  title: ReactNode;
  description?: ReactNode;
  status: StatusBubbleVariant;
  info?: ReactNode;
  actions?: ReactNode;
  footer?: ReactNode;
};

export const FieldAnnotationPopoverShell = ({
  style,
  title,
  description,
  status,
  info,
  actions,
  footer,
  ref,
}: WithRef<FieldAnnotationPopoverShellProps, HTMLDivElement>) => (
  <InfoPopover ref={ref} style={style}>
    <InfoPopoverBody className="*:not-first:mt-4">
      <Header title={title} description={description} status={status} />
      {info}
      {actions}
    </InfoPopoverBody>
    {footer ? <InfoPopoverFooter>{footer}</InfoPopoverFooter> : null}
  </InfoPopover>
);
